export const HomeTabData = {
  hot: [
    {
      name: "HEYVIP Super Ace",
      image: "/assets/Hot/JILI-SLOT-118.webp",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-118",
      platFormCode: "JILI",
    },
    {
      name: "Fortune Gems Legend",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-204",
      platFormCode: "JILI",
      image: "/assets/Hot/JILI-SLOT-204.webp",
    },

{
      name: "Fortune Gems",
      gameType: "SLOT",
      casinoType: "JILI-TABLE-068",
      platFormCode: "JILI",
      image: "/assets/Hot/JILI-TABLE-068.webp",
    },

{
      name: "Super Ace",
      image: "/assets/Hot/JILI-SLOT-027.webp",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-027",
      platFormCode: "JILI",
    },

    {
      name: "Fortune Garuda 500",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-193",
      platFormCode: "JILI",
      image: "/assets/Hot/JILI-SLOT-193.webp",
    },
 {
      name: "Fortune Gems 3",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-076",
      platFormCode: "JILI",
      image: "/assets/Hot/JILI-SLOT-076.webp",
    },

 {
      name: "Boxing King",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-031",
      platFormCode: "JILI",
      image: "/assets/Hot/JILI-SLOT-031.webp",
    },

{
      name: "Fortune Gems 500",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-138",
      platFormCode: "JILI",
      image: "/assets/Hot/JILI-SLOT-138.webp",
    },
{
      name: "Super Ace 2",
      image: "/assets/Hot/JILI-SLOT-130.webp",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-130",
      platFormCode: "JILI",
    },
  {
      name: "Fortune Gems 3",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-096",
      platFormCode: "JILI",
      image: "/assets/Hot/JILI-SLOT-096.webp",
    },

  {
      name: "ForCircus Joker 4096",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-136",
      platFormCode: "JILI",
      image: "/assets/Hot/JILI-SLOT-136.webp",
    },
    
    {
      name: "Money Coming",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-029",
      platFormCode: "JILI",
      image: "/assets/Hot/JILI-SLOT-029.webp",
    },
    {
      name: "HEYVIP Super Elements",
      gameType: "SLOT",
      casinoType: "FC-SLOT-033",
      platFormCode: "FC",
      image: "/assets/Hot/FC-SLOT-033.webp",
    },
      {
      name: "Aviator",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-001",
      platFormCode: "SPRIBE",
      image: "/assets/Hot/SPRIBE-EGAME-001.webp",
    },
  {
      name: "HEYVIP Crash",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-047",
      platFormCode: "TABLE",
      image: "/assets/Hot/JILI-TABLE-047.webp",
    },

    {
      name: "HEYVIP Pirate Legends",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-037",
      platFormCode: "YESBINGO",
      image: "/assets/Hot/YesBingo-SLOT-037.webp",
    },
  
    {
      name: "Crazy Time",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-006",
      platFormCode: "EVOLUTION",
      image: "/assets/Hot/EVOLUTION-LIVE-006.webp",
    },
    {
      name: "Sexy Baccarat",
      gameType: "LIVE",
      casinoType: "MX-LIVE-001",
      platFormCode: "SEXYBCRT",
      image: "/assets/Hot/MX-LIVE-001.webp",
    },
    {
      name: "Wild Bounty Showdown",
      gameType: "SLOT",
      casinoType: "PG-SLOT-105",
      platFormCode: "PG",
      image: "/assets/Hot/PG-SLOT-105.webp",
    },
     {
    name: "Treasures of Aztec",
    image: "/assets/Hot/PG-SLOT-058.webp",
    platForm: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-058",
    platFormCode: "PG",
  },
   {
    name: "Dragon Gems 500",
    image: "/assets/Hot/YesBingo-SLOT-054.webp",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-054",
    platFormCode: "YESBINGO",
  },
    {
      name: "Magic Ace Wild Lock",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-127",
      platFormCode: "JDB",
      image: "/assets/Hot/JDB-SLOT-127.webp",
    },
    {
    name: "Super Ace Deluxe",
    image: "/assets/Hot/JILI-SLOT-102.png",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-102",
    platFormCode: "JILI",
  },
   {
    name: "Funky Time",
    image: "/assets/Casino/EVOLUTION-LIVE-183.webp?v=1765933237553",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-183",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dream Catcher",
    image: "/assets/Casino/EVOLUTION-LIVE-035.webp?v=1765933237422",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-035",
    platFormCode: "EVOLUTION",
  },
    {
    name: "Ice Fishing",
    image: "/assets/Casino/EVOLUTION-LIVE-449.webp?v=1765933237748",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-449",
    platFormCode: "EVOLUTION",
  },
   {
    name: "Lightning Storm",
    image: "/assets/Casino/EVOLUTION-LIVE-369.webp?v=1765933237699",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-369",
    platFormCode: "EVOLUTION",
  },
  {
    name: "MONOPOLY Live",
    image: "/assets/Casino/EVOLUTION-LIVE-007.webp?v=1765933237400",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-007",
    platFormCode: "EVOLUTION",
  },
   {
    name: "Lightning Baccarat",
    image: "/assets/Casino/EVOLUTION-LIVE-133.webp?v=1765933237507",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-133",
    platFormCode: "EVOLUTION",
  },
    {
    name: "Crazy Balls",
    image: "/assets/Casino/EVOLUTION-LIVE-409.webp?v=1765933237718",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-409",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Mega Ball",
    image: "/assets/Casino/EVOLUTION-LIVE-010.webp?v=1765933237403",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-010",
    platFormCode: "EVOLUTION",
  },
   {
    name: "Sweet Bonanza Candyland",
    image: "/assets/Casino/PP-LIVE-044.Sweet-Bonanza-CandyLand.webp?v=1764405889106",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-044",
    platFormCode: "PP",
  },
  {
    name: "Money Time",
    image: "/assets/Casino/PP-LIVE-188.Money Time.webp?v=1764408167157",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-188",
    platFormCode: "PP",
  },
  ],
  sports: [
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKET",
      name: "9wickets",
      src: "/assets/Platform/icon-9w-cricket.png",
      alt: "icon-9w-cricket",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "Velki",
      src: "/assets/Icon/velki-favicon.ico",
      alt: "icon-cricket",
    },

    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "Sportsbook",
      src: "/assets/NewIcon/darkIcon.png",
      alt: "icon-cricket",
      gameType: "VIRTUAL",
      casinoType: "SABA-VIRTUAL-001",
      platFormCode: "SABA",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "BTI",
      src: "/assets/NewIcon/provider-sbtech.png",
      alt: "icon-cricket",
      gameType: "VIRTUAL",
      casinoType: "SABA-VIRTUAL-001",
      platFormCode: "SABA",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "InSports",
      src: "/assets/NewIcon/provider-awcv2_insports.png",
      alt: "icon-cricket",
      gameType: "VIRTUAL",
      casinoType: "SABA-VIRTUAL-001",
      platFormCode: "SABA",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "CMD",
      src: "/assets/NewIcon/provider-cmd.png",
      alt: "icon-cricket",
      gameType: "VIRTUAL",
      casinoType: "SABA-VIRTUAL-001",
      platFormCode: "SABA",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "Pinnacle",
      src: "/assets/NewIcon/provider-awcv2_pinnacle.png",
      alt: "icon-cricket",
      gameType: "SPORTS",
      casinoType: "PINNACLE-SPORTS-001",
      platFormCode: "PINNACLE",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "HorseBook",
      src: "/assets/NewIcon/icon-horsebook.png",
      alt: "icon-cricket",
      gameType: "LIVE",
      casinoType: "HRB-LIVE-001",
      platFormCode: "HORSEBOOK",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "SBO",
      src: "/assets/NewIcon/provider-sbov2.png",
      alt: "icon-cricket",

      gameType: "VIRTUAL",
      casinoType: "SABA-VIRTUAL-001",
      platFormCode: "SABA",
    },
  ],
  casino: [
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "EVOLUTION",
      name: "EVO",
      src: "../assets/Platform/provider-evo.png",
      alt: "provider-awcv2_evolution",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "SEXYBCRT",
      name: "SEXY",
      src: "../assets/Platform/provider-awcmsexy.png",
      alt: "provider-awcmsexy",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "PP",
      name: "PP",
      src: "../assets/Platform/provider-awcmpp.png",
      alt: "provider-awcmpp",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "PT",
      name: "PT",
      src: "../assets/Platform/provider-awcmpt.png",
      alt: "provider-awcmpt",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "DREAMGAMING",
      name: "DG",
      src: "../assets/Platform/provider-awcmdg.png",
      alt: "provider-awcmdg",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "HOTROAD",
      name: "HotRoad",
      src: "../assets/Platform/provider-awcmhotroad.png",
      alt: "provider-awcv2_hotroad",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "VIACASINO",
      name: "VIA",
      src: "../assets/Platform/provider-awcmvia.png",
      alt: "provider-awcmvia",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "CREEDROOMZ",
      name: "CreedRoomz",
      src: "../assets/Platform/provider-awcv2_creedroomz.png",
      alt: "provider-awcv2_creedroomz",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "WINFINITY",
      name: "WINFINITY",
      src: "../assets/Platform/provider-awcv2_winfinity.png",
      alt: "provider-awcv2_winfinity",
    },
  ],
  slots: [
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "PG",
      name: "PG",
      src: "../assets/Platform/provider-awcv2_pg.png",
      alt: "provider-awcv2_pg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "JDB",
      name: "JDB",
      src: "../assets/Platform/jdb.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "FC",
      name: "FC",
      src: "../assets/Platform/provider-awcmfc.png",
      alt: "provider-awcmfc",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "SPADE",
      name: "SG",
      src: "../assets/Platform/provider-awcmsg.png",
      alt: "provider-awcmsg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "FASTSPIN",
      name: "FASTSPIN",
      src: "../assets/Platform/provider-awcmfastspin.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmfastspin",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "PP",
      name: "PP",
      src: "../assets/Platform/provider-awcmpp.png",
      alt: "provider-awcmpp",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "YESBINGO",
      name: "YELLOW BAT",
      src: "../assets/Platform/provider-awcv2_yesbingo.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_yesbingo",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "BTG",
      name: "BTG",
      src: "../assets/Platform/provider-awcv2_btg.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_btg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "NLC",
      name: "NLC",
      src: "../assets/Platform/provider-awcv2_nlc.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_nlc",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "DRAGOONSOFT",
      name: "Dragoonsoft",
      src: "../assets/Platform/provider-awcv2_dragoonsoft.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_dragoonsoft",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "RT",
      name: "RT",
      src: "../assets/Platform/provider-awcmrt.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmrt",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "PT",
      name: "PT",
      src: "../assets/Platform/provider-awcmpt.png",
      alt: "provider-awcmpt",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "NETENT",
      name: "NETENT",
      src: "../assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
      alt: "provider-netent",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "PLAY8",
      name: "P8",
      src: "../assets/Platform/provider-awcmp8.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmp8",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "Joker",
      name: "Joker",
      src: "../assets/Platform/provider-joker.png?v=1772072361392&source=mcdsrc",
      alt: "provider-joker",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "PLAYNGO",
      name: "PNG",
      src: "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
      alt: "provider-playngo",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "KINGMAKER",
      name: "KM",
      src: "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "CG",
      name: "CG",
      src: "../assets/Platform/provider-awcmcg.png",
      alt: "provider-awcmcg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "YL",
      name: "YL",
      src: "../assets/Platform/yl.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "RELAX",
      name: "RELAX",
      src: "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_relax",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "OCTOPLAY",
      name: "OCTOPLAY",
      src: "../assets/Platform/provider-awcv2_octoplay.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_octoplay",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "ACEWIN",
      name: "ACEWiN",
      src: "../assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_acewin",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "HACKSAW",
      name: "HACKSAW",
      src: "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_hacksaw",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "JJ",
      name: "JJ",
      src: "../assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_jj",
    },

    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "YGGDRASIL",
      name: "YGGDRASIL",
      src: "../assets/Platform/provider-awcv2_yggdrasil.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_yggdrasil",
    },
  ],
  crash: [
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "SPRIBE",
      name: "JDBASPRIBE",
      src: "../assets/Platform/provider-jdbaspribe.png?v=1772072361392&source=mcdsrc",
      alt: "provider-jdbaspribe",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "JDB",
      name: "JDB",
      src: "../assets/Platform/jdb.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "FC",
      name: "FC",
      src: "../assets/Platform/provider-awcmfc.png",
      alt: "provider-awcmfc",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "PP",
      name: "PP",
      src: "../assets/Platform/provider-awcmpp.png",
      alt: "provider-awcmpp",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "KINGMAKER",
      name: "KM",
      src: "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },

    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "CG",
      name: "CG",
      src: "../assets/Platform/provider-awcmcg.png",
      alt: "provider-awcmcg",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "YL",
      name: "YL",
      src: "../assets/Platform/darkIcon.png",
    },

    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "RELAX",
      name: "RELAX",
      src: "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_relax",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "CRASH88",
      name: "CRASH88",
      src: "../assets/Platform/provider-awcv2_crash88.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_crash88",
    },
  ],
  table: [
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "KINGMAKER",
      name: "KM",
      src: "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },
    // {
    //   categoryType: "VENDOR",
    //   gameType: 256,
    //   vendor: "RICH88",
    //   name: "RICH88",
    //   src: "../assets/Platform/provider-rich88.png?v=1772072361392&source=mcdsrc",
    //   alt: "provider-rich88",
    // },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "SPRIBE",
      name: "JDBASPRIBE",
      src: "../assets/Platform/provider-jdbaspribe.png?v=1772072361392&source=mcdsrc",
      alt: "provider-jdbaspribe",
    },

    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "NETENT",
      name: "NETENT",
      src: "../assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
      alt: "provider-netent",
    },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "PT",
      name: "PT",
      src: "../assets/Platform/provider-awcmpt.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmpt",
    },
    // {
    //   categoryType: "VENDOR",
    //   gameType: 256,
    //   vendor: "PLAYNGO",
    //   name: "PNG",
    //   src: "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
    //   alt: "provider-playngo",
    // },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "PG",
      name: "PG",
      src: "../assets/Platform/provider-awcv2_pg.png",
      alt: "provider-awcv2_pg",
    },

    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "RELAX",
      name: "RELAX",
      src: "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_relax",
    },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "HACKSAW",
      name: "HACKSAW",
      src: "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_hacksaw",
    },
  ],
  fishing: [
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "JDB",
      name: "JDB",
      src: "../assets/Platform/jdb.png?v=1770791064378",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "FC",
      name: "FC",
      src: "../assets/Platform/provider-awcmfc.png",
      alt: "provider-awcmfc",
    },

    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "FASTSPIN",
      name: "FASTSPIN",
      src: "../assets/Platform/provider-awcmfastspin.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmfastspin",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "SPADE",
      name: "SPADE",
      src: "../assets/Platform/provider-awcmsg.png",
      alt: "provider-awcmsg",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "YESBINGO",
      name: "YELLOW BAT",
      src: "../assets/Platform/provider-awcv2_yesbingo.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_yesbingo",
    },

    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "ACEWIN",
      name: "ACEWiN",
      src: "../assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_acewin",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "JJ",
      name: "JJ",
      src: "../assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_jj",
    },
    // {
    //   categoryType: "VENDOR",
    //   gameType: 8,
    //   vendor: "GTF",
    //   name: "GTF",
    //   src: "../assets/Platform/provider-awcv2_gtf.png?v=1772072361392&source=mcdsrc",
    //   alt: "provider-awcv2_gtf",
    // },
  ],
  arcade: [
    // {
    //   categoryType: "VENDOR",
    //   gameType: 1024,
    //   vendor: "RICH88",
    //   name: "RICH88",
    //   src: "../assets/Platform/provider-rich88.png?v=1772072361392&source=mcdsrc",
    //   alt: "provider-rich88",
    // },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "JDB",
      name: "JDB",
      src: "../assets/Platform/jdb.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "FC",
      name: "FC",
      src: "../assets/Platform/provider-awcmfc.png",
      alt: "provider-awcmfc",
    },

    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "PP",
      name: "PP",
      src: "../assets/Platform/provider-awcmpp.png",
      alt: "provider-awcmpp",
    },

    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "PG",
      name: "PG",
      src: "../assets/Platform/provider-awcv2_pg.png",
      alt: "provider-awcv2_pg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "KINGMAKER",
      name: "KM",
      src: "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },

    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "CG",
      name: "CG",
      src: "../assets/Platform/provider-awcmcg.png",
      alt: "provider-awcmcg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "YL",
      name: "YL",
      src: "../assets/Platform/darkIcon.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "RELAX",
      name: "RELAX",
      src: "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_relax",
    },
    // {
    //   categoryType: "VENDOR",
    //   gameType: 1024,
    //   vendor: "HACKSAW",
    //   name: "HACKSAW",
    //   src: "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
    //   alt: "provider-awcv2_hacksaw",
    // },
  ],
  lottery: [
    {
      categoryType: "VENDOR",
      gameType: 64,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 64,
      vendor: "KINGMAKER",
      name: "KM",
      src: "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },
    {
      categoryType: "VENDOR",
      gameType: 64,
      vendor: "YESBINGO",
      name: "YELLOW BAT",
      src: "../assets/Platform/provider-awcv2_yesbingo.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_yesbingo",
    },
  ],
};
export const HomeFooterPlatform = [
  {
    name: "saba",
    image: "/assets/Footer/provider-saba.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "jdb",
    image: "/assets/Footer/provider-jdb.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "jdbaspribe",
    image:
      "/assets/Footer/provider-jdbaspribe.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "cq9",
    image: "/assets/Footer/provider-cq9.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "pg",
    image: "/assets/Footer/provider-pg.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "evo",
    image: "/assets/Footer/provider-evo.webp?v=1772072361392&source=mcdsrc",
  },

  {
    name: "netent",
    image: "/assets/Footer/provider-netent.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "png",
    image: "/assets/Footer/provider-png.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "rich88",
    image: "/assets/Footer/provider-rich88.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "worldmatch",
    image:
      "/assets/Footer/provider-worldmatch.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmsexy",
    image:
      "/assets/Footer/provider-awcmsexy.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmrt",
    image: "/assets/Footer/provider-awcmrt.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmsg",
    image: "/assets/Footer/provider-awcmsg.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmkm",
    image: "/assets/Footer/provider-awcmkm.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmjili",
    image:
      "/assets/Footer/provider-awcmjili.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmp8",
    image: "/assets/Footer/provider-awcmp8.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmfc",
    image: "/assets/Footer/provider-awcmfc.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmhotroad",
    image:
      "/assets/Footer/provider-awcmhotroad.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmpp",
    image: "/assets/Footer/provider-awcmpp.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmpt",
    image: "/assets/Footer/provider-awcmpt.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "horsebook",
    image: "/assets/Footer/icon-horsebook.svg?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmfastspin",
    image:
      "/assets/Footer/provider-awcmfastspin.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmyesbingo",
    image:
      "/assets/Footer/provider-awcmyesbingo.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "sv388",
    image: "/assets/Footer/icon-sv388.svg?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcme1sport",
    image:
      "/assets/Footer/provider-awcme1sport.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmrwb",
    image: "/assets/Footer/provider-awcmrwb.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmpinnacle",
    image:
      "/assets/Footer/provider-awcmpinnacle.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "nst",
    image: "/assets/Footer/icon-nst.svg?v=1772072361392&source=mcdsrc",
  },
];
export const HomeFavourite = [
  {
    name: "HEYVIP Super Ace",
    image: "/assets/Hot/JILI-SLOT-027.png",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-027",
  },
   {
      name: "Fortune Gems Legend",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-204",
      platFormCode: "JILI",
      image: "/assets/Hot/JILI-SLOT-204.png",
    },
    {
      name: "Fortune Garuda 1000",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-225",
      platFormCode: "JILI",
      image: "/assets/Hot/JILI-SLOT-225.png",
    },
  {
    name: "Super Ace",
    image: "/assets/Hot/JILI-SLOT-142.png",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-142",
    platFormCode: "JILI",
  },
  {
      name: "Fortune Garuda 500",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-193",
      platFormCode: "JILI",
      image: "/assets/Hot/JILI-SLOT-193.png",
    },
  {
    name: "Super Ace Deluxe",
    image: "/assets/Hot/JILI-SLOT-102.png",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-102",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Gems 500",
    image: "/assets/Hot/JILI-SLOT-204.png",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-204",
  },
   {
    name: "Wild Bounty Showdown",
    image: "/assets/Hot/PG-SLOT-105.png",
    gameType: "SLOT",
    casinoType: "PG-SLOT-105",
    platFormCode: "PG",
  },
  {
    name: "Boxing King",
    image: "/assets/Hot/JILI-SLOT-031.png",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-031",
    platFormCode: "JILI",
  },
 
  
];
export const filtercasion = [
  {
    name: "PT",
    image: "../assets/Platform/provider-awcmpt.png",
  },
  {
    name: "VIACASINO",
    image: "../assets/Platform/provider-awcmvia.png",
  },
  {
    name: "PP",
    image: "../assets/Platform/provider-awcmpp.png",
  },
  {
    name: "EVOLUTION",
    image: "../assets/Platform/provider-evo.png",
  },
  {
    name: "SEXYBCRT",
    image: "../assets/Platform/provider-awcmsexy.png",
  },
  {
    name: "HOTROAD",
    image: "../assets/Platform/provider-awcmhotroad.png",
  },
  {
    name: "DREAMGAMING",
    image: "../assets/Platform/provider-awcmdg.png",
  },
  {
    name: "CREEDROOMZ",
    image: "../assets/Platform/provider-awcv2_creedroomz.png",
  },
  {
    name: "WINFINITY",
    image: "../assets/Platform/provider-awcv2_winfinity.png",
  },
];

export const filterslot = [
  {
    name: "PG",
    image: "../assets/Platform/provider-awcv2_pg.png",
  },
  {
    name: "CG",
    image: "../assets/Platform/provider-awcmcg.png",
  },

  {
    name: "DRAGOONSOFT",
    image: "../assets/Platform/provider-dragoonsoft.png",
  },
  {
    name: "PP",
    image: "../assets/Platform/provider-awcmpp.png",
  },
  {
    name: "PT",
    image: "../assets/Platform/provider-awcmpt.png",
  },
  {
    name: "KINGMAKER",
    image:
      "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "RT",
    image: "../assets/Platform/provider-awcmrt.png",
  },
  {
    name: "BTG",
    image:
      "../assets/Platform/provider-awcv2_btg.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JILI",
    image: "../assets/Platform/provider-awcmjili.png",
  },
  {
    name: "NETENT",
    image:
      "../assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JDB",
    image: "../assets/Platform/provider-jdb.png",
  },
  {
    name: "FC",
    image: "../assets/Platform/provider-awcmfc.png",
  },
  {
    name: "NLC",
    image: "../assets/Platform/provider-nlc.png",
  },
  {
    name: "FASTSPIN",
    image: "../assets/Platform/provider-awcmfastspin.png",
  },
  {
    name: "YGGDRASIL",
    image:
      "../assets/Platform/provider-awcv2_yggdrasil.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "SPADE",
    image: "../assets/Platform/provider-awcmsg.png",
  },
  {
    name: "JJ",
    image:
      "../assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "Joker",
    image: "../assets/Platform/provider-joker.png",
  },
  {
    name: "OCTOPLAY",
    image: "../assets/Platform/provider-awcv2_octoplay.png",
  },
  {
    name: "PLAYNGO",
    image:
      "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  },

  {
    name: "ACEWIN",
    image:
      "../assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "PLAY8",
    image: "../assets/Platform/provider-awcmp8.png",
  },
  {
    name: "RELAX",
    image:
      "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "YESBINGO",
    image: "../assets/Platform/provider-awcmyesbingo.png",
  },
  {
    name: "YL",
    image: "../assets/Platform/yl.png",
  },
];

export const filtertable = [
  {
    image: "../assets/Platform/provider-awcmjili.png",
    name: "JILI",
  },
  {
    name: "HACKSAW",
    image:
      "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
  },
  {
    image: "../assets/Platform/provider-awcmkm.png",
    name: "KINGMAKER",
  },
  {
    name: "NETENT",
    image:
      "../assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "PT",
    image: "../assets/Platform/provider-awcmpt.png",
  },
  // {
  //   name: "PLAYNGO",
  //   image:
  //     "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  // },
  {
    name: "RELAX",
    image:
      "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  // {
  //   image: "../assets/Platform/provider-rich88.png",
  //   name: "RICH88",
  // },
  {
    name: "PG",
    image: "../assets/Platform/provider-awcv2_pg.png",
  },
  {
    image: "../assets/Platform/provider-jdbaspribe.png",
    name: "SPRIBE",
  },
];

export const filtercrash = [
  {
    image: "../assets/Platform/provider-jdbaspribe.png",
    name: "SPRIBE",
  },
  {
    name: "JDB",
    image: "../assets/Platform/provider-jdb.png",
  },
  {
    name: "YL",
    image: "../assets/Platform/yl.png",
  },
  {
    name: "RELAX",
    image:
      "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  {
    image: "../assets/Platform/provider-awcmjili.png",
    name: "JILI",
  },
  {
    name: "PP",
    image: "../assets/Platform/provider-awcmpp.png",
  },
  {
    name: "CG",
    image: "../assets/Platform/provider-awcmcg.png",
  },
  // {
  //   image: "../assets/Platform/provider-rich88.png",
  //   name: "RICH88",
  // },
  // {
  //   name: "Joker",
  //   image: "../assets/Platform/provider-joker.png",
  // },
  // {
  //   name: "SMARTSOFT",
  //   image:
  //     "../assets/Platform/provider-awcv2_smartsoft.png?v=1772072361392&source=mcdsrc",
  // },
  {
    image: "../assets/Platform/provider-awcmkm.png",
    name: "KINGMAKER",
  },
  // {
  //   name: "PLAYNGO",
  //   image:
  //     "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  // },
  {
    image: "../assets/Platform/provider-awcmfc.png",
    name: "FC",
  },
  {
    image:
      "../assets/Platform/provider-awcv2_crash88.png?v=1772072361392&source=mcdsrc",
    name: "CRASH88",
  },
];

export const filterfishing = [
  {
    name: "JILI",
    image: "../assets/Platform/provider-awcmjili.png",
  },
  {
    name: "SPADE",
    image: "../assets/Platform/provider-awcmsg.png",
  },
  {
    name: "FC",
    image: "../assets/Platform/provider-awcmfc.png",
  },
  {
    name: "YESBINGO",
    image: "../assets/Platform/provider-awcmyesbingo.png",
  },
  {
    name: "ACEWIN",
    image:
      "../assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JDB",
    image: "../assets/Platform/provider-jdb.png",
  },
  {
    name: "FASTSPIN",
    image:
      "../assets/Platform/provider-awcmfastspin.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JJ",
    image:
      "../assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
  },
  // {
  //   name: "JOKER",
  //   image: "../assets/Platform/provider-joker.png",
  // },
  // {
  //   name: "GTF",
  //   image:
  //     "../assets/Platform/provider-awcv2_gtf.png?v=1772072361392&source=mcdsrc",
  // },
];

export const filterarcade = [
  {
    image: "../assets/Platform/provider-awcv2_pg.png",
    name: "PG",
  },
  {
    name: "JILI",
    image: "../assets/Platform/provider-awcmjili.png",
  },
  {
    name: "PP",
    image: "../assets/Platform/provider-awcmpp.png",
  },
  {
    name: "KINGMAKER",
    image:
      "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "CG",
    image: "../assets/Platform/provider-awcmcg.png",
  },
  {
    image: "../assets/Platform/provider-jdb.png",
    name: "JDB",
  },
  {
    image: "../assets/Platform/provider-awcmfc.png",
    name: "FC",
  },
  // {
  //   name: "HACKSAW",
  //   image:
  //     "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
  // },
  {
    image: "../assets/Platform/provider-awcmyl.png",
    name: "YL",
  },
  {
    name: "RELAX",
    image:
      "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  // {
  //   image: "../assets/Platform/provider-rich88.png",
  //   name: "RICH88",
  // },
];

export const filterlotto = [
  {
    image: "../assets/Platform/provider-awcmjili.png",
    name: "JILI",
  },

  {
    name: "YESBINGO",
    image: "../assets/Platform/provider-awcmyesbingo.png",
  },
  {
    name: "KINGMAKER",
    image:
      "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
  },
  // {
  //   name: "PLAYNGO",
  //   image:
  //     "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  // },
  // {
  //   name: "HACKSAW",
  //   image:
  //     "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
  // },
  // {
  //   name: "Joker",
  //   image: "../assets/Platform/provider-joker.png",
  // },
  // {
  //   name: "RICH88",
  //   image: "../assets/Platform/provider-rich88.png",
  // },
];

export const HomeIcon = {
  sports: `../assets/Icon/icon-sport.png`,
  casino: "../assets/Icon/icon-casino.png",
  slots: "../assets/Icon/icon-slot.png",
  table: "../assets/Icon/icon-table.png",
  crash: "../assets/Icon/icon-crash.png",
  fishing: "../assets/Icon/icon-fish.png",
  arcade: "../assets/Icon/icon-arcade.png",
  lotto: "../assets/Icon/icon-lottery.png",
};
